<template>
  <div class="page-wrapper">
    <menu-dispatcher></menu-dispatcher>
    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">
                <router-link to="/directories/garbage-removal">
                  <a class="back" title="Назад"><img src="../image/back.png"></a>
                </router-link>
                {{ isNew ? 'Добавить' : 'Редактировать' }}
              </div>
              <div class="cabinet-body"></div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directory-box">
                  <div class="main-content">
                    <div class="head-panel visibility">
                      <span class="table-string-delete" v-show="!isNew" @click="remove"><i class="fa fa-trash-o"></i>Удалить строку</span>
                    </div>
                    <div class="form">
                      <div class="fieldset">
                        <label class="fieldset-title">Наименование района</label>
                        <fieldset :class="{'fieldset-error': errors.has('name')}">
                          <input type="text" v-model="name"
                                 v-validate="'required'" :class="{'input': true}" name="name">
                          <span v-show="errors.has('name')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Надбавка, руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('surcharge')}">
                          <input type="number" v-model="surcharge"
                                 v-validate="'required'" :class="{'input': true}" name="surcharge">
                          <span v-show="errors.has('surcharge')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="buttons">
                        <button type="button" class="save-button" @click="save">
                          Сохранить
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
    import api from '@/api'
    import VeeValidate from 'vee-validate'

    export default {
  name: 'GarbageDisposalDistrict',
  components: {
    MenuDispatcher,
    HeaderDispatcher,
    VeeValidate
  },

  data () {
    return {
      id: null,
      isNew: false,
      garbageDisposalDistrict: {},
      newGarbageDisposalDistrict: {}
    }
  },

  computed: {
    name: {
      get () {
        return !this.isNew ? this.garbageDisposalDistrict.name : this.newGarbageDisposalDistrict.name
      },

      set (name) {
        !this.isNew ? this.garbageDisposalDistrict.name = name : this.newGarbageDisposalDistrict.name = name
      }
    },
    surcharge: {
      get () {
        return !this.isNew ? this.garbageDisposalDistrict.surcharge : this.newGarbageDisposalDistrict.surcharge
      },

      set (surcharge) {
        !this.isNew ? this.garbageDisposalDistrict.surcharge = surcharge : this.newGarbageDisposalDistrict.surcharge = surcharge
      }
    }
  },

  mounted () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.add('cabinet-page')

    this.id = this.$route.params.id
    if (this.id == 'new') {
      this.isNew = true
      this.newGarbageDisposalDistrict = {
        name: null,
        surcharge: null
      }
    } else {
      api
        .getGarbageDisposalDistrictById(this.id)
        .then(garbageDisposalDistrict => {
          if (garbageDisposalDistrict) {
            this.garbageDisposalDistrict = garbageDisposalDistrict
            this.isNew = false
          }
        })
    }
  },

  destroyed () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.remove('cabinet-page')
  },

  methods: {
    remove () {
      this.garbageDisposalDistrict.removed = true
      this.save()
    },

    save () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isNew
            ? api
              .createGarbageDisposalDistrict(this.newGarbageDisposalDistrict)
              .then(() => {
                this.$router.push('/directories/garbage-removal')
                alert('Сохранено')
              })
              .catch(err => alert(err))
            : api
              .updateGarbageDisposalDistrict(this.id, this.garbageDisposalDistrict)
              .then(() => {
                this.$router.push('/directories/garbage-removal')
                alert('Сохранено')
              })
              .catch(err => alert(err))
        }
      })
    }
  }
}
</script>
